import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.ExcelExports';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class ExcelExports extends RpcClass{

    /**
     *  @class ExcelExports
     *  @alias module:src/server/com/silkplm/rpc/ExcelExports.ExcelExports
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param formClass {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     downloadXlsxTemplateFile(formClass) {
            return RpcClass.rpcCall('/rpc/excel-exports/download-xlsx-template-file', [formClass]);
    }
    /** 
     * @async
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @param streamSelection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     exportAllDynamicAttributesToExcel(streamingQuery, streamSelection) {
            return RpcClass.rpcCall('/rpc/excel-exports/export-all-dynamic-attributes-to-excel', [streamingQuery, streamSelection]);
    }
    /** 
     * @async
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     exportBudgetingPlannerPMRecordsStreamingModeToExcelFileWithNoSelection(streamingQuery) {
            return RpcClass.rpcCall('/rpc/excel-exports/export-budgeting-planner-p-m-records-streaming-mode-to-excel-file-with-no-selection', [streamingQuery]);
    }
    /** 
     * @async
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @param ids {number[]} 
     * @param selectedBudgetingPlannerEntities {number[]} 
     * @param excludedBudgetingPlannerEntities {number[]} 
     * @param allSelectedMode {boolean} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     exportBudgetingPlannerPMRecordsStreamingModeToExcelFileWithSelection(streamingQuery, ids, selectedBudgetingPlannerEntities, excludedBudgetingPlannerEntities, allSelectedMode) {
            return RpcClass.rpcCall('/rpc/excel-exports/export-budgeting-planner-p-m-records-streaming-mode-to-excel-file-with-selection', [streamingQuery, ids, selectedBudgetingPlannerEntities, excludedBudgetingPlannerEntities, allSelectedMode]);
    }
    /** 
     * @async
     * @param plannerPMList {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     exportBudgetingPlannerPMRecordsToExcelFile(plannerPMList) {
            return RpcClass.rpcCall('/rpc/excel-exports/export-budgeting-planner-p-m-records-to-excel-file', [plannerPMList]);
    }
    /** 
     * @async
     * @param plannerPMList {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository>}
     */
     exportBudgetingPlannerPMRecordsToExcelFileFileInRepository(plannerPMList) {
            return RpcClass.rpcCall('/rpc/excel-exports/export-budgeting-planner-p-m-records-to-excel-file-file-in-repository', [plannerPMList]);
    }
    /** 
     * @async
     * @param selectedRecords {module:src/server/com/silkplm/model/plm/Product.Product[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     exportDynamicAttributesToExcel(selectedRecords) {
            return RpcClass.rpcCall('/rpc/excel-exports/export-dynamic-attributes-to-excel', [selectedRecords]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     findLimitForExportedImages() {
            return RpcClass.rpcCall('/rpc/excel-exports/find-limit-for-exported-images', []);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param selectedIdsList {string[]} 
     * @param formId {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     listDynamicExtendedEntities(clazzName, selectedIdsList, formId) {
            return RpcClass.rpcCall('/rpc/excel-exports/list-dynamic-extended-entities', [clazzName, selectedIdsList, formId]);
    }
    /** 
     * @async
     * @param masterClazz {string} 
     * @param masterId {string} 
     * @param formId {number} 
     * @param selectedIdsList {number[]} 
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @param streamSelection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     listExtendedEntities(masterClazz, masterId, formId, selectedIdsList, streamingQuery, streamSelection) {
            return RpcClass.rpcCall('/rpc/excel-exports/list-extended-entities', [masterClazz, masterId, formId, selectedIdsList, streamingQuery, streamSelection]);
    }
    /** 
     * @async
     * @param masterClazz {string} 
     * @param masterId {string} 
     * @param formId {number} 
     * @param filterId {string} 
     * @param selectedIdsList {number[]} 
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @param streamSelection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     listExtendedEntitiesClustered(masterClazz, masterId, formId, filterId, selectedIdsList, streamingQuery, streamSelection) {
            return RpcClass.rpcCall('/rpc/excel-exports/list-extended-entities-clustered', [masterClazz, masterId, formId, filterId, selectedIdsList, streamingQuery, streamSelection]);
    }
    /** 
     * @async
     * @param masterClazz {string} 
     * @param masterId {string} 
     * @param formId {number} 
     * @param filterId {string} 
     * @param colFiltersSpecs {string} 
     * @param selectedIdsList {number[]} 
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @param streamSelection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     listExtendedEntitiesClusteredWithColFilters(masterClazz, masterId, formId, filterId, colFiltersSpecs, selectedIdsList, streamingQuery, streamSelection) {
            return RpcClass.rpcCall('/rpc/excel-exports/list-extended-entities-clustered-with-col-filters', [masterClazz, masterId, formId, filterId, colFiltersSpecs, selectedIdsList, streamingQuery, streamSelection]);
    }
    /** 
     * @async
     * @param masterClazz {string} 
     * @param masterId {string} 
     * @param formId {number} 
     * @param colFiltersSpecs {string} 
     * @param dynamicColFiltersSpecs {string} 
     * @param selectedIdsList {number[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     listExtendedEntitiesDynamicWithColFilters(masterClazz, masterId, formId, colFiltersSpecs, dynamicColFiltersSpecs, selectedIdsList) {
            return RpcClass.rpcCall('/rpc/excel-exports/list-extended-entities-dynamic-with-col-filters', [masterClazz, masterId, formId, colFiltersSpecs, dynamicColFiltersSpecs, selectedIdsList]);
    }
    /** 
     * @async
     * @param masterClazz {string} 
     * @param masterId {string} 
     * @param formId {number} 
     * @param colFiltersSpecs {string} 
     * @param selectedIdsList {number[]} 
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @param selection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     listExtendedEntitiesWithColFilters(masterClazz, masterId, formId, colFiltersSpecs, selectedIdsList, streamingQuery, selection) {
            return RpcClass.rpcCall('/rpc/excel-exports/list-extended-entities-with-col-filters', [masterClazz, masterId, formId, colFiltersSpecs, selectedIdsList, streamingQuery, selection]);
    }
    /** 
     * @async
     * @param masterClazz {string} 
     * @param masterId {string} 
     * @param formId {number} 
     * @param fieldName {string} 
     * @param filterClazz {string} 
     * @param filteringInstance {string} 
     * @param selectedIdsList {number[]} 
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @param streamSelection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     listExtendedEntitiesWithFiltering(masterClazz, masterId, formId, fieldName, filterClazz, filteringInstance, selectedIdsList, streamingQuery, streamSelection) {
            return RpcClass.rpcCall('/rpc/excel-exports/list-extended-entities-with-filtering', [masterClazz, masterId, formId, fieldName, filterClazz, filteringInstance, selectedIdsList, streamingQuery, streamSelection]);
    }
    /** 
     * @async
     * @param masterClazz {string} 
     * @param masterId {string} 
     * @param formId {number} 
     * @param fieldName {string} 
     * @param filterClazz {string} 
     * @param filteringInstance {string} 
     * @param colFiltersSpecs {string} 
     * @param selectedIdsList {number[]} 
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @param streamSelection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     listExtendedEntitiesWithFilteringWithColFilters(masterClazz, masterId, formId, fieldName, filterClazz, filteringInstance, colFiltersSpecs, selectedIdsList, streamingQuery, streamSelection) {
            return RpcClass.rpcCall('/rpc/excel-exports/list-extended-entities-with-filtering-with-col-filters', [masterClazz, masterId, formId, fieldName, filterClazz, filteringInstance, colFiltersSpecs, selectedIdsList, streamingQuery, streamSelection]);
    }
    /** 
     * @async
     * @param clazzName {string} 
     * @param filterId {string} 
     * @param colFiltersSpecs {string} 
     * @param streamingQuery {module:src/server/com/silkplm/rpc/dto/streaming/FormStreamingQuery.FormStreamingQuery} 
     * @param streamSelection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/DelayedTask.DelayedTask>}
     */
     listViewFromStream(clazzName, filterId, colFiltersSpecs, streamingQuery, streamSelection) {
            return RpcClass.rpcCall('/rpc/excel-exports/list-view-from-stream', [clazzName, filterId, colFiltersSpecs, streamingQuery, streamSelection]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.ExcelExports';
metadata.__type_short__ = 'ExcelExports';
ExcelExports.prototype.__metadata__ = metadata;

ExcelExports.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/ExcelExports */
export default ExcelExports

export { ExcelExports }
